import React from 'react';
import { Typography } from '@mui/material';
import { ErrorMessage, useFormikContext } from 'formik';
import { InputRowType } from '../../interfaces';
import InputRow from './InputRow';

interface Props {
  rows: InputRowType[];
  name: string;
}

function dedupeMessages(messages: string[]) {
  return Array.from(new Set(messages));
}

export default function InputGroup({ rows, name }: Props) {
  const { values, setFieldValue, errors, touched } = useFormikContext<any>();

  // filter object to only include errors that are touched
  const actualErrors = React.useMemo(
    () =>
      Object.keys(errors).reduce(
        (acc, key) => {
          if (touched[key]) {
            acc[key] = errors[key];
          }
          return acc;
        },
        {} as typeof errors,
      ),
    [errors, touched],
  );

  return (
    <div className="input-group">
      <Typography variant="h2">{name}</Typography>
      <div className="inputs">
        {rows.map((row, index) => (
          <InputRow
            inputs={row}
            values={values}
            setFieldValue={setFieldValue}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            formName={name}
          />
        ))}
      </div>
      {!!Object.values(actualErrors)?.length && (
        <div className="input-group-errors">
          {rows.map(row =>
            row.map(input => (
              <div className="error-message" key={`${input.name}-error`}>
                <ErrorMessage
                  name={input.name}
                  render={msg => {
                    const messages =
                      typeof msg === 'object' && Array.isArray(msg)
                        ? dedupeMessages(msg)
                        : msg;
                    return messages;
                  }}
                />
              </div>
            )),
          )}
        </div>
      )}
    </div>
  );
}
